import React from "react";
import PropTypes from "prop-types";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Box,
  Paper,
} from "@mui/material";

const CartStepper = ({
  orderId,
  patientName,
  steps,
  activeStep,
  onStepChange,
  showNavigation = true,
}) => {
  const handleNext = (nextAction) => {
    if(nextAction){
      nextAction();
    } else {
      onStepChange(activeStep + 1);
    }
  };

  const handleBack = () => {
    onStepChange(activeStep - 1);
  };

  return (
    <div>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((step) => (
          <Step
            key={step.label}
            sx={{ cursor: "pointer" }}
          >
            <StepLabel
              StepIconProps={{
                sx: {
                  '&.Mui-completed': {
                    color: '#0f7a48',
                  },
                  '&.Mui-active': {
                    color: '#2563eb',
                  },
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      <div style={{ padding: 10, marginTop: 20, marginBottom: 2 }}>
        <Box>
          <div className="flex justify-between mb-5">
            <div className="font-semibold">
              <div className="text-sm">
                Order ID: <span className="font-semibold">{orderId} </span>
              </div>
              <div className="text-sm">
                Patient Name:{" "}
                <span className="font-semibold">{patientName} </span>
              </div>
            </div>
          </div>
          {activeStep === steps.length ? (
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                All steps completed
              </Typography>
              <Button onClick={() => onStepChange(0)} sx={{ mt: 1 }}>
                Reset
              </Button>
            </Box>
          ) : (
            <Box>
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #eee",
                  borderRadius: 1,
                  minHeight: "100px",
                }}
              >
                {steps[activeStep].content}
              </Box>

              {showNavigation && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    pt: 2,
                  }}
                >
                  <button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    style={{
                      border: activeStep === 0 ? "1px solid #888" : "1px solid black",
                    }}
                    className={
                      activeStep === 0
                        ? "text-gray-500 cursor-default rounded-md w-40 p-1 text-sm font-semibold"
                        : "text-black cursor-pointer rounded-md w-40 p-1 text-sm font-semibold"
                    }
                  >
                    Back
                  </button>
                  {activeStep < steps.length - 1 ? (
                    <button
                      onClick={() => handleNext(steps[activeStep].nextAction)}
                      disabled={steps[activeStep].disabled}
                      className={
                        steps[activeStep].disabled
                          ? "border-gray-500 bg-gray-500 text-gray-100 border cursor-default rounded-md w-40 p-1 text-sm font-semibold"
                          : "border-blue-600 bg-blue-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold"
                      }
                    >
                      Next
                    </button>
                  ) : (
                    <></>
                  )}
                </Box>
              )}
            </Box>
          )}
        </Box>
      </div>
    </div>
  );
};

CartStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node,
    })
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func.isRequired,
  showNavigation: PropTypes.bool,
};

export default CartStepper;
